<template>
  <div class="cardOrganiser">
    <div class="biddingTabContainer"> 
      <div class="biddingTab" v-for="(bidding, key) in biddingList" :key="`tab_${key}`" @click="()=>selectBidding(bidding)" :class="currentBidding._id === bidding._id ? 'active' : ''">
        <div class="biddingTabLabel">{{ key + 1 }} - {{ bidding.biddingTitle }}</div>
      </div>
      <div class="biddingTab" :key="`tab_add`" @click="()=>addBidding()">
        <div class="biddingTabLabel">
          <i class="el-icon-plus"/> Bidding Title
        </div>
      </div>
    </div>
    <template v-if="currentBidding._id">
      <div class="cardOrganiser" v-loading="biddingLoading">
        <div class="cardOrganiser" style="margin: 15px 0px;">
          <div class="cardColumn">
            <div style="width: 100%; display: flex; flex-direction: row; flex-wrap: wrap; gap: 5px;">
              <span style="font-size: 25px; color: var(--v4-dark-font-color);">{{ currentBidding.biddingTitle }}</span>
              <template>
                <div style="display: flex; flex-direction: row; flex-wrap: wrap; flex: 1; justify-content: flex-end;">
                  <el-button style="padding: 10px;" v-if="!noEditRoles.includes(branchRole)" v-loading="btnloading" type="transparent" @click="()=>handleSaveBidding()">{{ 'Save Bidding Title' }}</el-button>
                  <el-button style="padding: 10px;" v-if="!noEditRoles.includes(branchRole)" v-loading="btnloading" type="danger" @click="()=>biddingTitleRemove()">{{ 'Remove Bidding Title' }}</el-button>
                </div>
              </template>
            </div>
          </div>
          <div class="cardColumn" style="max-width: 50%; min-width: min-content;">
            <div class="cardContent" style="">
              <el-form-item label="Title:" required>
                <el-input
                ref="biddingTitle"
                class="el-input-size"
                v-model="currentBidding.biddingTitle"
                style="width: 90%; margin-bottom: 20px;">
                </el-input>
              </el-form-item>
              <el-form-item label="Description:" required>
                <el-input
                ref="biddingDescription"
                class="el-input-size"
                v-model="currentBidding.biddingDescription"
                style="width: 90%; margin-bottom: 20px;"
                :autosize="{ minRows: 3 }"
                type="textarea">
                </el-input>
              </el-form-item>
              <el-form-item style="" label="1. Open Bidding?" required>
                <el-radio-group v-model="openBidding" style="margin-bottom: 0px;">
                  <el-radio v-for="(openBiddingOption, index) in openBiddingOptions" :key="index" :label="openBiddingOption.value" >{{ openBiddingOption.label }}</el-radio>
                </el-radio-group>
              </el-form-item>
              <el-form-item label="DMT Remarks: (not visible to CI)" required>
                <el-input
                ref="biddingDMURemarks"
                class="el-input-size"
                v-model="currentBidding.biddingDMURemarks"
                style="width: 90%; margin-bottom: 20px;"
                :autosize="{ minRows: 3 }"
                type="textarea">
                </el-input>
              </el-form-item>
            </div>
            <div class="cardContent" style="">
              <el-form-item style="" label="2. Start and Close Bidding Date" required>
                <div class="cardOrganiser" style="justify-content: flex-start;">
                  <v-date-picker v-model="biddingCloseDate" is-inline mode="range" :attributes="attributes" :disabled-dates="disabledDates" @update:to-page="fetchCalendarData" ref="calendar"/>
                </div>
              </el-form-item>
            </div>
          </div>
          <div class="cardColumn" style="max-width: 50%; min-width: 300px;">
            <div class="cardContent" style="">
              <el-form-item style="" label="3. Required Site Visit?" required>
                <el-radio-group v-model="currentBidding.biddingSiteVisitRequired" style="display: flex; flex-direction: row;">
                  <el-radio v-for="(siteVisitOption, index) in siteVisitOptions" :key="index" :label="siteVisitOption.value" >{{ siteVisitOption.label }}</el-radio>
                </el-radio-group>
              </el-form-item>
              <el-form-item v-if="currentBidding.biddingSiteVisitRequired" label="Site Visit Date" required>
                <div class="cardOrganiser" style="justify-content: flex-start;">
                  <v-date-picker v-model="biddingSiteVisitDate" is-inline mode="range" :attributes="attributes" :disabled-dates="disabledDates" @update:to-page="fetchCalendarData" ref="calendar"/>
                </div>
              </el-form-item>
              <el-form-item v-if="currentBidding.biddingSiteVisitRequired" label="Site Visit Address:" required>
                <el-input
                  ref="biddingSiteVisitAddress"
                  class="el-input-size"
                  v-model="currentBidding.biddingSiteVisitAddress"
                  style="width: 90%; margin-bottom: 20px;"
                  :autosize="{ minRows: 3 }"
                  type="textarea">
                </el-input>
              </el-form-item>
              <el-form-item label="Briefing Date" required>
                <div class="cardOrganiser" style="justify-content: flex-start;">
                  <v-date-picker v-model="biddingBriefingDate" is-inline mode="range" :attributes="attributes" :disabled-dates="disabledDates" @update:to-page="fetchCalendarData" ref="calendar"/>
                </div>
              </el-form-item>
              <el-form-item style="margin-bottom: 20px;" label="4. Bidding type" required>
                <el-select
                  ref="biddingtype"
                  style="width: 200px;"
                  class="el-input-size"
                  v-model="currentBidding.biddingType"
                  :disabled="locked">
                  <el-option
                    v-for="(biddingTypeOption, index) in biddingTypeOptions"
                    :key="index"
                    :label="biddingTypeOption.label"
                    :value="biddingTypeOption.value">
                  </el-option>
                </el-select>
              </el-form-item>
            </div>
            <div class="cardContent" style="">
              <el-form-item style="margin-bottom: 20px;" label="5. RFQ">
                <div style="display: flex; flex-direction: row; align-items: flex-start; justify-content: flex-start; margin-bottom: 5px;">
                  <el-button type="transparent smaller" @click="()=>uploadBiddingDocuments()" :disabled="locked">
                    <i class="el-icon-plus"/>
                    Upload
                  </el-button>
                </div>  
                <div style="display: flex; flex-direction: column;">
                  <div style="display: flex; flex-direction: row;" v-for="(file, filekey) in projectsubmissionbiddingdocumentfiles" :key="filekey">
                    <el-button type="danger smaller" style="height: 30px; margin-right: 10px;" @click="()=>deleteBiddingDocument(file)" :disabled="locked">
                      <i class="el-icon-delete"/>
                    </el-button>
                    <a :href="file.url" target="_blank" class="fileLink" style="font-size: 16px;">{{ file.name }}</a>
                  </div>
                </div>
              </el-form-item>
            </div>
          </div>
          <!-- <div class="el-button-mobile-container center">
            <el-button  v-loading="btnloading" type="transparent" @click="()=>onSubmit(false, true)"> Save As Draft </el-button>
            <el-button  v-loading="btnloading" type="primary" @click="()=>onSubmit(true, true)"> Confirm</el-button>
          </div> -->
        </div>
        <div class="cardSubtitleType1 noMarginLeft">Invite CI for Bidding</div>
        <div class="cardColumn">
          <div style="color: var(--darker-border-color);" class="cardSubtitleType1 noMarginLeft noUnderline">{{ currentBidding.biddingTitle }}</div>
        </div>
        <div class="cardOrganiser" style="display: flex; flex-direction: row; gap: 20px;">
          <!-- <div class="card" style="max-width: 250px">
            <div class="cardContent" style="padding: 5px 10px; max-width: 250px;">
              <el-form-item label="Select CI Entity Type" style="margin-left: 5px;">
                <el-checkbox-group v-model="CIentitytype" style="display: flex; flex-direction: column; ">
                  <el-checkbox v-for="(entitytypeOption, index) in entitytypeOptions" :key="index" :label="entitytypeOption.value" :disabled="locked">
                    {{ entitytypeOption.label }}
                  </el-checkbox>
                </el-checkbox-group>
              </el-form-item>
            </div>
            <div class="cardContent" style="padding: 5px 10px; max-width: 250px;">
              <el-form-item label="Select CI Technology" style="margin-left: 5px;">
                <el-checkbox-group v-model="CIpillarir" style="display: flex; flex-direction: column;">
                  <el-checkbox v-for="(pillariroption, index) in pillariroptions" :key="index" :label="pillariroption.value" :disabled="locked">
                  {{ pillariroption.label }}
                  </el-checkbox>
                </el-checkbox-group>
              </el-form-item>
            </div>
          </div> -->
          <div class="cardColumn" style="flex: 1; min-width: 300px;">
            <!-- <div style="display:flex; flex-direction: row; justify-content: flex-start; width: 100%;">
              <el-input placeholder="Search Company" style="max-width: 300px; margin-right: 10px;" @change="()=>fetchData()" v-model="search">
                <i slot="prefix" class="el-input__icon el-icon-search"></i>
              </el-input>
              <el-button type="primary smaller" style="height: 40px;" @click="()=>selectAll()">Select All</el-button>
            </div> -->
            <div style="overflow-x: scroll; transform: rotateX(180deg); width: 100%;">
              <div style="transform: rotateX(180deg);">
                <div class="cardTableHeader">
                  <p class="cardValue2 cardTableHeaderBox" style="min-width: 30px; max-width: 40px;">No.</p>
                  <p class="cardValue2 cardTableHeaderBox" style="min-width: 160px; flex: 1; ">Vendor Name</p>
                  <!-- <p class="cardValue2 cardTableHeaderBox" style="max-width: 140px;">Contact details</p> -->
                  <p class="cardValue2 cardTableHeaderBox" style="min-width: 100px; max-width: 250px;">Type of Entity</p>
                  <p class="cardValue2 cardTableHeaderBox" style="min-width: 100px; max-width: 250px;">Business Sector</p>
                  <p class="cardValue2 cardTableHeaderBox" style="min-width: 100px; max-width: 250px;">Pillar IR4.0</p>
                  <p class="cardValue2 cardTableHeaderBox" style="min-width: 100px; max-width: 100px;">Actions</p>
                </div>
                <div
                  v-for="(item, key) in filteredUsers2"
                  :key="key"
                  class="cardTableRow"
                  :class="item.companyActiveTickedFlag === true ? 'selectedTableRow' : ''">
                  <div
                    class="cardTableRowContent">
                    <p class="cardValue2 cardTableRowBox" style="min-width: 30px; max-width: 40px;">
                      <span>{{  indexMethod(key) }}.</span>
                    </p>
                    <p class="cardValue2 cardTableRowBox" style="min-width: 160px; flex: 1; padding-right: 8px;">
                      <span class="cardTableRowSharedText">
                        {{ item.vendorname ? item.vendorname : '-' }}
                      </span>
                    </p>
                    <!-- <p class="cardValue2 cardTableRowBox" style="max-width: 140px;">
                      <span class="cardTableRowSharedText">
                        {{ item.contactpersonsalutation ? item.contactpersonsalutation : ''  }}
                        {{ item.contactpersonname ? item.contactpersonname : '-'  }}
                      </span>
                      <span class="cardTableRowSharedText" style="color: var(--darker-border-color)"> 
                        {{ item.email ? item.email : '-'  }}
                      </span>
                      <span class="cardTableRowSharedText" style="color: var(--darker-border-color)"> 
                        {{ item.handphone ? item.handphone : '-'  }}
                      </span>
                    </p> -->
                    <p class="cardValue2 cardTableRowBox" style="min-width: 100px; max-width: 250px;">
                      <span class="cardTableRowSharedText" style="word-break: break-word; white-space: normal; overflow: hidden; text-overflow: ellipsis; word-wrap: break-word; ">
                        {{ item.entitytype.map((v) => {
                          const label = entitytypeOptions.find((option)=>option.value === v)
                          return label ? label.label : v
                        }).join(', ') }}
                      </span>
                    </p>
                    <p class="cardValue2 cardTableRowBox" style="min-width: 100px; max-width: 250px;">
                      <span class="cardTableRowSharedText" style="word-break: break-word; white-space: normal; overflow: hidden; text-overflow: ellipsis; word-wrap: break-word; ">
                        {{ item.businesssector ? item.businesssector : '-' }}
                      </span>
                    </p>
                    <p class="cardValue2 cardTableRowBox" style="min-width: 100px; max-width: 250px;">
                      <span class="cardTableRowSharedText" style="word-break: break-word; white-space: normal; overflow: hidden; text-overflow: ellipsis; word-wrap: break-word; ">
                        {{ item.pillarir ? item.pillarir.map((item)=>{
                          const label = pillariroptions.find((option)=>option.value === item)
                          return label ? label.label : '-'
                        }).join(', ') : '-' }}
                      </span>
                    </p>
                    <p class="cardValue2 cardTableRowBox" style="min-width: 100px; max-width: 100px;">
                      <el-button type="primary smaller" @click="()=>createCISelection(item)" v-if="item.companyActiveTickedFlag === false">Select</el-button>
                      <el-button type="primary smaller" @click="()=>deleteCISelection2(item)" v-else>Deselect</el-button>
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <div class="pagination-container">
              <el-pagination
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page.sync="page2"
                :page-sizes="[5, 15, 30, 50, 100]"
                :page-size="limit2"
                layout="prev, pager, next, sizes"
                :total="total2"
                style="float:right;">
              </el-pagination>
            </div>
          </div>
        </div>
        <div style="margin-top: 20px;" class="cardSubtitleType1 noMarginLeft">CIs Selected For Invitation</div>
        <div class="cardOrganiser" style="display: flex; flex-direction: row; gap: 20px;">
          <div class="cardColumn" style="flex: 1; min-width: 300px;">
            <!-- <div style="display:flex; flex-direction: row; justify-content: flex-start; width: 100%;">
              <el-input placeholder="Search Company" style="max-width: 300px; margin-right: 10px;" @change="()=>fetchData()" v-model="search">
                <i slot="prefix" class="el-input__icon el-icon-search"></i>
              </el-input>
              <el-button type="primary smaller" style="height: 40px;" @click="()=>deselectAll()">Deselect All</el-button>
            </div> -->
            <div style="overflow-x: scroll; transform: rotateX(180deg); width: 100%;">
              <div style="transform: rotateX(180deg);">
                <div class="cardTableHeader">
                  <p class="cardValue2 cardTableHeaderBox" style="min-width: 30px; max-width: 40px;">No.</p>
                  <p class="cardValue2 cardTableHeaderBox" style="min-width: 160px; flex: 1; ">Vendor Name</p>
                  <!-- <p class="cardValue2 cardTableHeaderBox" style="max-width: 140px;">Contact details</p> -->
                  <p class="cardValue2 cardTableHeaderBox" style="min-width: 100px; max-width: 250px;">Type of Entity</p>
                  <p class="cardValue2 cardTableHeaderBox" style="min-width: 100px; max-width: 250px;">Business Sector</p>
                  <p class="cardValue2 cardTableHeaderBox" style="min-width: 100px; max-width: 250px;">Pillar IR4.0</p>
                  <p class="cardValue2 cardTableHeaderBox" style="min-width: 100px; max-width: 100px;">Actions</p>
                </div>
                <div
                  v-for="(item, key) in currentBiddingCISelections"
                  :key="key"
                  class="cardTableRow selectedTableRow">
                  <div
                    class="cardTableRowContent">
                    <p class="cardValue2 cardTableRowBox" style="min-width: 30px; max-width: 40px;">
                      <span>{{  indexMethod(key) }}.</span>
                    </p>
                    <p class="cardValue2 cardTableRowBox" style="min-width: 160px; flex: 1; padding-right: 8px;">
                      <span class="cardTableRowSharedText">
                        {{ item.vendorname ? item.vendorname : '-' }}
                      </span>
                    </p>
                    <!-- <p class="cardValue2 cardTableRowBox" style="max-width: 140px;">
                      <span class="cardTableRowSharedText">
                        {{ item.contactpersonsalutation ? item.contactpersonsalutation : ''  }}
                        {{ item.contactpersonname ? item.contactpersonname : '-'  }}
                      </span>
                      <span class="cardTableRowSharedText" style="color: var(--darker-border-color)"> 
                        {{ item.email ? item.email : '-'  }}
                      </span>
                      <span class="cardTableRowSharedText" style="color: var(--darker-border-color)"> 
                        {{ item.handphone ? item.handphone : '-'  }}
                      </span>
                    </p> -->
                    <p class="cardValue2 cardTableRowBox" style="min-width: 100px; max-width: 250px;">
                      <span class="cardTableRowSharedText" style="word-break: break-word; white-space: normal; overflow: hidden; text-overflow: ellipsis; word-wrap: break-word; ">
                        {{ item.entitytype.map((v) => {
                          const label = entitytypeOptions.find((option)=>option.value === v)
                          return label ? label.label : v
                        }).join(', ') }}
                      </span>
                    </p>
                    <p class="cardValue2 cardTableRowBox" style="min-width: 100px; max-width: 250px;">
                      <span class="cardTableRowSharedText" style="word-break: break-word; white-space: normal; overflow: hidden; text-overflow: ellipsis; word-wrap: break-word; ">
                        {{ item.businesssector ? item.businesssector : '-' }}
                      </span>
                    </p>
                    <p class="cardValue2 cardTableRowBox" style="min-width: 100px; max-width: 250px;">
                      <span class="cardTableRowSharedText" style="word-break: break-word; white-space: normal; overflow: hidden; text-overflow: ellipsis; word-wrap: break-word; ">
                        {{ item.pillarir ? item.pillarir.map((item)=>{
                          const label = pillariroptions.find((option)=>option.value === item)
                          return label ? label.label : '-'
                        }).join(', ') : '-' }}
                      </span>
                    </p>
                    <p class="cardValue2 cardTableRowBox" style="min-width: 100px; max-width: 100px;">
                      <el-button type="primary smaller" @click="()=>deleteCISelection(item)">Deselect</el-button>
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </template>
    <template v-else>
      <div class="cardOrganiser">
        <div class="cardColumn" style="flex: 1; min-width: 300px;">
          <div class="cardContent" style=""></div>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
export default {
  name: 'BiddingDetails',
  props: {
    biddingList: Array,
    currentBidding: Object,
    biddingLoading: Boolean,
    noEditRoles: Array,
    branchRole: String,
    openBidding: Boolean,
    openBiddingOptions: Array,
    biddingCloseDate: Date,
    attributes: Array,
    disabledDates: Array,
    siteVisitOptions: Array,
    projectsubmissionbiddingdocumentfiles: Array,
    biddingTypeOptions: Array,
    locked: Boolean,
    filteredUsers2: Array,
    entitytypeOptions: Array,
    pillariroptions: Array,
    currentBiddingCISelections: Array,
    page2: Number,
    limit2: Number,
    total2: Number
  },
  methods: {
    indexMethod(index) {
      return index + 1 + (this.page - 1) * this.limit;
    },
    selectBidding(bidding) {
      this.$emit('selectBidding', bidding);
    },
    addBidding() {
      this.$emit('addBidding');
    },
    handleSaveBidding() {
      this.$emit('handleSaveBidding');
    },
    biddingTitleRemove() {
      this.$emit('biddingTitleRemove');
    },
    fetchCalendarData(toPage) {
      this.$emit('fetchCalendarData', toPage);
    },
    uploadBiddingDocuments() {
      this.$emit('uploadBiddingDocuments');
    },
    deleteBiddingDocument(file) {
      this.$emit('deleteBiddingDocument', file);
    },
    createCISelection(item) {
      this.$emit('createCISelection', item);
    },
    deleteCISelection2(item) {
      this.$emit('deleteCISelection2', item);
    },
    handleSizeChange(size) {
      this.$emit('handleSizeChange', size);
    },
    handleCurrentChange(page) {
      this.$emit('handleCurrentChange', page);
    },
    deleteCISelection(item) {
      this.$emit('deleteCISelection', item);
    }
  }
}
</script>

<style scoped>
.cardSubtitleType1 {
  font-size: 18px;
  font-weight: bold;
  margin-bottom: 10px;
}
.biddingTabContainer {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  gap: 10px;
  margin-bottom: 20px;
}
.biddingTab {
  cursor: pointer;
  padding: 10px;
  border: 1px solid var(--darker-border-color);
  border-radius: 5px;
  transition: background-color 0.3s ease;
}
.biddingTab.active {
  background-color: var(--primary-color);
  color: white;
}
.biddingTabLabel {
  font-size: 16px;
}
.cardOrganiser {
  display: flex;
  flex-direction: column;
  gap: 20px;
}
.cardColumn {
  display: flex;
  flex-direction: column;
  gap: 10px;
}
.cardContent {
  display: flex;
  flex-direction: column;
  gap: 10px;
}
.cardTableHeader {
  display: flex;
  flex-direction: row;
  background-color: var(--lighter-border-color);
  padding: 10px;
  border-radius: 5px;
}
.cardTableRow {
  display: flex;
  flex-direction: row;
  padding: 10px;
  border-bottom: 1px solid var(--lighter-border-color);
}
.cardTableRow.selectedTableRow {
  background-color: var(--primary-color-light);
}
.cardTableRowContent {
  display: flex;
  flex-direction: row;
  flex: 1;
  align-items: center;
}
.cardValue2 {
  font-size: 14px;
}
.cardValue2.cardTableHeaderBox {
  font-weight: bold;
}
.cardValue2.cardTableRowBox {
  display: flex;
  align-items: center;
}
.fileLink {
  color: var(--primary-color);
  text-decoration: none;
}
.fileLink:hover {
  text-decoration: underline;
}
.pagination-container {
  display: flex;
  justify-content: flex-end;
  margin-top: 20px;
}
</style>



// WEBPACK FOOTER //
// src/views/sfera/components/BiddingDetails.vue